import { all, takeLatest } from "redux-saga/effects";

import { GET_AUTH } from "../actions";
import { authSaga } from "./AuthSaga";

export default function* () {
  yield all([takeLatest(GET_AUTH, authSaga)]);
}
